/** Align Activity toolbar controls with Ticket Information / dashboard primary */
export const ACTIVITY_PRIMARY = "#6366f1";
export const ACTIVITY_PRIMARY_HOVER = "#4f46e5";

/** MUI `Button variant="outlined"` — filter & export toolbars */
export const activityToolbarOutlinedSx = {
  border: `1px solid ${ACTIVITY_PRIMARY}`,
  color: ACTIVITY_PRIMARY,
  "&:hover": {
    border: `1px solid ${ACTIVITY_PRIMARY_HOVER}`,
    backgroundColor: "rgba(99, 102, 241, 0.06)",
  },
  "&.Mui-disabled": {
    border: "1px solid rgba(148, 163, 184, 0.55)",
    color: "rgba(100, 116, 139, 0.85)",
    backgroundColor: "#f9fafb",
  },
} as const;